module.exports = __webpack_public_path__ + "static/media/ler02.3d151c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Lokalni-Razvoj/ler02.jpg
// module id = 384
// module chunks = 0